import { useCallback } from 'react'
import cookieStorage from 'cookie-storage'
import { constants } from 'helpers'
import { useCookieCoupon } from 'modules/coupon'
import { usePrices } from 'modules/subscription'


export const useSubscribeButton = (defaultCouponCode?: string) => {
  const { couponCode, setCookieCoupon } = useCookieCoupon(defaultCouponCode)

  const country = cookieStorage.getItem(constants.cookieNames.country)

  const { formattedPrice, formattedPriceWithDiscount, formattedExtraShippingPrice, eventDiscountText,
    discountPercent, discountAmount, isFetching, offerType } = usePrices({ couponCode, country })

  const discountText = discountPercent || discountAmount

  const handleSubscribeClick = useCallback(() => {
    setCookieCoupon(couponCode)
  }, [ setCookieCoupon, couponCode ])

  return {
    couponCode,
    formattedPrice,
    formattedPriceWithDiscount,
    formattedExtraShippingPrice,
    offerType,
    discountText,
    eventDiscountText,
    isFetching,
    handleSubscribeClick,
  }
}
